export default "__VITE_ASSET__CWxEGKCr__"